const isAdmin = (user) => user?.roles?.some((r) => r.value === 'admin');
const isManager = (user) => user?.roles?.some((r) => r.value === 'manager');
const isOrderManager = (user) => user?.roles?.some((r) => r.value === 'order-manager');
const isStoneManager = (user) => user?.roles?.some((r) => r.value === 'stone-manager');
const isQcManager = (user) => user?.roles?.some((r) => r.value === 'qc-manager');
const isStockManager = (user) => user?.roles?.some((r) => r.value === 'stock-manager');
const isReadOnly = (user) => user?.roles?.some((r) => r.value === 'read-only');
const isAccounting = (user) => user?.roles?.some((r) => r.value === 'accounting');
const isDeveloper = (user) => user?.roles?.some((r) => r.value === 'developer');

const canOrderDelete = (user) => isAdmin(user) || isManager(user);
const canOrderEdit = (user) => isAdmin(user) || isManager(user) || isOrderManager(user) || isStoneManager(user) || isStockManager(user) || isQcManager(user);
const canOrderCreate = (user) => isAdmin(user) || isManager(user);
const canQcEditOnly = (user) => isQcManager(user) && !isAdmin(user) && !isManager(user) && !isOrderManager(user) && !isStoneManager(user) && !isStockManager(user);
const canAccessEtsyAccounting = (user) => isAdmin(user) || isAccounting(user);
const canAccessAnirudhBhaiya = (user) => isAdmin(user) || isManager(user);


export { 
    isAdmin, 
    isManager, 
    isOrderManager, 
    isStoneManager, 
    isQcManager, 
    isStockManager, 
    isReadOnly,
    canOrderDelete,
    canOrderEdit,
    canOrderCreate,
    canQcEditOnly,
    isAccounting,
    isDeveloper,
    canAccessEtsyAccounting,
    canAccessAnirudhBhaiya,
};